import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AsyncPipe, NgClass, NgOptimizedImage} from '@angular/common';
import {LoginService} from './login.service';
import {InputOtpModule} from 'primeng/inputotp';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import {Toast} from 'primeng/toast';
import {SpinnerOverlayService} from '../Components/spinner/spinner-overlay.service';
import {CountdownModule} from 'ngx-countdown';
import {HttpStatusCode} from '@angular/common/http';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import {AccountService} from './account.service';
import {Router} from '@angular/router';
import {VersionService} from '../shared/service/version.service';
import {MessageService} from '../shared/message.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    NgClass,
    InputOtpModule,
    FontAwesomeModule,
    Toast,
    NgOptimizedImage,
    CountdownModule,
    AsyncPipe
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone: true,
})
export class LoginComponent implements OnInit {
  email: string | null = null
  loading: boolean = false
  showOTPScreen: boolean = false
  otp: string = ""
  isOTPInvalid: boolean = false
  showCountdown = false;
  isCodeVerificationCorrect = false
  countdownConfig = { leftTime: 120, format: 'mm:ss' };
  //icons
  faTriangleExclamation = faTriangleExclamation;
  faArrowLeft = faArrowLeft;
  faCheckCircle = faCheckCircle;
  readonly versionLabel$: Observable<string>;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private spinner: SpinnerOverlayService,
    private accountService: AccountService,
    private messageService: MessageService,
    private readonly versionService: VersionService
  ) {
    this.versionLabel$ = this.versionService.versionLabel$;
  }

  ngOnInit() {
    this.handleLoading(true)
    const token = localStorage.getItem('token');
    if (token) {
      this.accountService.loadIdentity(true).subscribe(() => {
        if (this.accountService.isAuthenticated()) {
          const warehouseCodes = this.accountService.warehouseCodes();
          if (warehouseCodes.length > 1) {
            this.accountService.selectedWarehouseCode.set(null);
          }
          this.handleLoading(false)
          if (this.accountService.hasAnyAuthority('COMPRADOR')) {
            this.router.navigate(['/home/pedidos']);
          } else {
            this.router.navigate(['/home']);
          }
          return;
        }
        this.handleLoading(false)
      });
    } else {
      this.handleLoading(false)
    }
  }

  login(resetOTPCode = false) {
    this.handleLoading(true)

    this.loginService.sendOtp(this.email!!.trim()).subscribe({
      next: () => {
        this.handleLoading(false)
        this.showOTPScreen = true
        this.showCountdown = true
        if (resetOTPCode) {
          this.messageService.showSuccess("Código OTP enviado")
          this.isOTPInvalid = false
          this.otp = ''
        }
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }

  getButtonClasses() {
    if (this.loading) return 'bg-orange-300 text-white cursor-not-allowed';
    if (!this.email) return 'text-gray-300 bg-gray-100';
    return 'bg-orange-500 text-white cursor-pointer';
  }

  validateOTPCode() {
    if (this.otp?.length === 6) {
      this.handleLoading(true)
      this.loginService.validateOTP(this.email!.trim(), this.otp).subscribe({
        next: (response) => {
          this.handleCorrectOTPValidation(response);
        },
        error: (error) => {
          if (error.status === HttpStatusCode.Unauthorized) {
            error.handled = true;
            this.handleOTPCode(true)
          } else {
            this.otp = ''
          }
          this.handleLoading(false)
        }
      });
    } else {
      this.handleOTPCode(false);
    }
  }

  private handleCorrectOTPValidation(response: { token: string }) {
    this.accountService.markAuthenticated();
    localStorage.setItem('token', response.token);
    this.getAccountAndNavigateToHome(response)
  }

  getAccountAndNavigateToHome(response: any) {
    this.handleLoading(true)
    this.handleOTPCode(false)
    this.isCodeVerificationCorrect = true
    
    this.accountService.loadIdentity(true).subscribe(() => {
      const warehouseCodes = this.accountService.warehouseCodes();
      if (warehouseCodes.length > 1) {
        this.accountService.selectedWarehouseCode.set(null);
      }
      this.handleLoading(false)
      setTimeout(() => {
        if (this.accountService.hasAnyAuthority('COMPRADOR')) {
          this.router.navigate(['/home/pedidos']);
        } else {
          this.router.navigate(['/home']);
        }
      }, 1000);
    });
  }

  private handleOTPCode(isInvalid: boolean) {
    this.isOTPInvalid = isInvalid
  }

  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  onCountdown(event: any) {
    if (event.action === 'done') {
      this.showCountdown = false;
    }
  }

  goBack() {
    this.showOTPScreen = false
  }
}
